let _ = t => t,
  _t;
import { Flex } from 'foundations-components/components/Flex';
import { Fragment } from 'react';
import { createGlobalStyle } from 'styled-components';
import MobileLayer from './MobileLayer';
import MobilePanelTransition from './internal/MobilePanelTransition';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePanelGlobalStyle = createGlobalStyle(_t || (_t = _`
  #hubspot-messages-iframe-container {
    z-index: 0 !important;
  }
  body {
    top: ${0};
  }
`), `-${window.scrollY}px`);
const MobilePanel = ({
  align = 'right',
  animate = true,
  ['data-test-id']: dataTestId,
  children,
  onOpenStart,
  onOpenComplete,
  onCloseStart,
  onCloseComplete,
  open,
  panelKey: __panelKey,
  rootNode
}) => {
  return open ? /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobilePanelGlobalStyle, {}), /*#__PURE__*/_jsx(MobileLayer, {
      rootNode: rootNode,
      Transition: MobilePanelTransition,
      transitionProps: {
        onOpenStart,
        onOpenComplete,
        onCloseStart,
        onCloseComplete,
        align,
        animate
      },
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "stretch",
        blockSize: "100%",
        "data-test-id": dataTestId,
        overflowX: "hidden",
        overflowY: "auto",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          minBlockSize: "100%",
          inlineSize: "100%",
          children: children
        })
      })
    })]
  }) : null;
};
export default MobilePanel;